/**
 * Function which returns a flag indicating whether or not it is running under cypress
 * @returns boolean flag indicating whether or not this being run under cypress
 */
export function isRunningCypress(): boolean {
  return Boolean(typeof window !== "undefined" && window.Cypress);
}
